/* global LayersPortal */
import Vue from "vue";
import Router from "vue-router";
import _ from "lodash";
import store from "@/store";
import Axios from "axios";

// Services
import Auth from "@/services/Auth";
import Community from "@/services/Community";
import NotFound from "@/pages/NotFound";

// Pages
import Home from "@/pages/Home";
import Submit from "@/pages/Submit";
import Registration from "@/pages/Registration";
import SignUp from "@/pages/SignUp";
import Admin from "@/pages/Admin";
import AdminEvent from "@/pages/Admin/AdminEvent";
import EventsDraw from "@/pages/Admin/EventsDraw";

import JudgeRegistration from "@/pages/JudgeRegistration";
import CommunityScheduler from "@/admin/Scheduler";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      alias: "/",
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        title: "Home",
        auth: true,
      },
    },
    {
      path: "/signup/:community?",
      name: "signup",
      component: SignUp,
      meta: {
        title: "Cadastrar-se",
        auth: false,
      },
      props: true,
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      meta: {
        title: "Painel Administrativo",
        auth: false,
      },
    },
    {
      path: "/admin/events/:id",
      name: "admin.event",
      component: AdminEvent,
      props: true,
      meta: {
        auth: false,
      },
    },
    {
      path: "/admin/events/:id/draws",
      name: "admin.event.draw",
      component: EventsDraw,
      props: true,
      meta: {
        auth: false,
      },
    },
    {
      path: "/registration",
      name: "registration",
      component: Registration,
      meta: {
        title: "Inscrever no torneio",
        auth: false,
      },
    },
    {
      path: "/submit",
      name: "submit",
      component: Submit,
      meta: {
        title: "Submeter inscrição",
        auth: true,
      },
      props: true,
    },
    {
      path: "/judge/registration",
      name: "judge-registration",
      component: JudgeRegistration,
      meta: {
        title: "Inscrever-se como Juiz",
        auth: true,
      },
    },
    {
      path: "/admin/scheduler",
      name: "admin.scheduler",
      component: CommunityScheduler,
      meta: {
        title: "Agendador",
        auth: true,
      },
    },
    {
      path: "*",
      name: "NotFound",
      component: NotFound,
      meta: {
        title: "Página não encontrada",
      },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  // Check backend status
  Axios.get("/status").then(
    (res) => {
      console.log(res.data);
    },
    () => {
      return next({
        name: "NotFound",
        // query: { redirect: to.fullPath }
      });
    },
  );

  let community = _.get(to.query, "community");
  let token = _.get(to.query, "token");

  await LayersPortal.readyPromise;
  if (LayersPortal.platform && LayersPortal.connected) {
    (await LayersPortal) && LayersPortal.connectedPromise;

    community = await window.LayersPortal("getCommunity");
    token = await window.LayersPortal("getAccountToken");
  }

  /*
   * Save Community
   */
  if (community && !Community.hasCommunity()) {
    Community.setCommunity(community);
    store.commit("setCommunity", community);
  }

  const isJudgeDefined = "isJudge" in to.query;
  if (isJudgeDefined) {
    store.commit("setIsJudge", Boolean(to.query.isJudge));
  }

  /*
   * Save token
   */
  if (token && !Auth.isLoggedIn()) {
    Auth.setToken(token);
    store.commit("setToken", token);
  }

  /*
   * Checks if the route requires authentication.
   * If so, redirect to login page
   */
  if (to.meta.auth && (!Auth.isLoggedIn() || !Community.hasCommunity())) {
    return next({
      name: "NotFound",
      query: { redirect: to.fullPath },
    });
  }

  /*
   * Change title
   */
  let title = "Torneio de Robótica";
  const parts = to.matched
    .filter((route) => route.meta && route.meta.title)
    .map((route) => route.meta.title);

  if (parts.length > 0) {
    title = parts.join(" > ");
  }
  document.title = title;

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js